import { IGuideType } from '../entity/einvoice/IUser';
import { setUserPreferences } from '../redux/reducers/ActiveUserReducer';
import { changeUserPreferences } from '../repository/UserRepository';

export const changeGuideState = (guideId: IGuideType, isOpen: boolean, dispatch: any) => {
  changeUserPreferences({ guide: { [guideId]: isOpen } });
  dispatch(setUserPreferences({ guide: { [guideId]: isOpen } }));
};
